import PropTypes from 'prop-types';
import React from 'react';
import sanitizeHtml from 'sanitize-html';
import * as S from './Text.styles';

export const TextAppearance = {
  ARTICLE: 'article',
  AUTHOR: 'author',
  REDUCED: 'reduced',
  INFO: 'info',
  NORMAL: 'normal',
  IMPORTANT: 'important',
};

export const Text = ({ children, type, center, color }) => {
  if (!children) {
    return null;
  }

  var childrenWithNoFollow = children.replaceAll(
    '#nofollow"',
    '" rel="nofollow noopener noreferrer"'
  );

  return (
    <S.Text
      center={center}
      color={color}
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(childrenWithNoFollow, {
          allowedAttributes: {
            a: ['href', 'rel', 'target'],
            h2: ['id'],
            h3: ['id'],
          },
        }),
      }}
      type={type}
    />
  );
};

Text.propTypes = {
  /**
   * Center text vertically in its div.
   */
  center: PropTypes.bool,
  /**
   * The displayed content of the button.
   */
  children: PropTypes.string.isRequired,
  /**
   * Color text.
   */
  color: PropTypes.string,
  /**
   * Change font-size and font-weight depending of the type.
   */
  type: PropTypes.oneOf(Object.values(TextAppearance)),
};

Text.defaultProps = {
  type: TextAppearance.ARTICLE,
  center: false,
};
